import React, { useState, useEffect, useContext } from 'react';
import { Navbar, Nav, Container, NavDropdown, Modal, Form } from 'react-bootstrap';
import { NavLink, useNavigate } from 'react-router-dom';
import AccountSettingsDialog from './AccountSettingsDialog';
import CustomizeWidget from '../components/CustomizeWidget';
import { useDialogContext } from '../context/DialogContext';
import { AuthContext } from '../context/AuthContext';
import { showSweetAlert } from '../components/SweetAlert';
import SwitchAccount from './SwitchAccount';
import ETradeAuthorization from '../auth/ETradeAuthorization';
import Authorization from '../auth/Authorization';
import EtradeAccSelection from './EtradeAccSelection';

function Header() {
  const [showSupport, setShowSupport] = useState(false);
  const [openAccSettings, setOpenAccSettings] = useState(false);
  const [switchAccount, setSwitchAccount] = useState(false);
  const [etradeAuth, setEtradeAuth] = useState(false);
  const [openAccSelect, setOpenAccSelect] = useState(false);
  const [issueType, setIssueType] = useState('');
  const [description, setDescription] = useState('');
  const { userData, supportEmail, setThirdParyAccount, updateUserData, holdingsData, getOrderData, eTradeAuth, setEtradeAuthData, openSettings, handleCloseSettings, integrationsParams, aiSettings, etradeAllAcc, accountsSummary, getWatchLists, preformanceData, fetchUserData } = useContext(AuthContext)
  const [name, setName] = useState("");
  const [errors, setErrors] = useState({ issueType: '', description: '' });
  const [showAccounts, setShowAccounts] = useState(false);

  const [alreadyAccount, setAlreadyAccount] = useState([]);
  const [showAuthorization, setShowAuthorization] = useState(false);
  const [etradeIntegrationName, setEtradeIntegrationName] = useState('');

  const handleShowSupport = () => setShowSupport(true);
  const handleCloseSupport = () => setShowSupport(false);
  const handleOpenAccSettings = () => setOpenAccSettings(true);
  const handleCloseAccSettings = () => setOpenAccSettings(false);
  const handleOpenSwitchAccount = () => setSwitchAccount(true);
  const handleCloseSwitchAccount = () => setSwitchAccount(false);
  const handleOpenEtradeAuth = () => setEtradeAuth(true);
  const handleCloseEtradeAuth = () => setEtradeAuth(false);
  const handleOpenAccSelect = () => setOpenAccSelect(true);
  const handleCloseAccSelect = () => setOpenAccSelect(false);

  const { openCustomizeWidget, closeCustomizeWidget, isCustomizeWidgetOpen } = useDialogContext();

  const handleShowCustomWidget = () => {
    openCustomizeWidget();
  };

  const handleCloseCustomWidget = () => {
    closeCustomizeWidget();
  };

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  const handleSubmit =async (event) => {
    event.preventDefault();

    let valid = true;
    let newErrors = { ...errors };

    if (!issueType) {
      console.log('no email');
      newErrors.issueType = 'Select any one issue';
      valid = false;
    } else if (!description) {
        console.log('no email');
        newErrors.description = 'Description is required.';
        valid = false;
    }else {
        newErrors.issueType = '';
        newErrors.description = '';
    }
    setErrors(newErrors);

    console.log('Submitting issue:', {
      issueType,
      description,
    });

    if (valid) {
      const response = supportEmail(issueType, description);
      if(response === "Email sent successfully."){
          handleCloseSupport(); 
          showSweetAlert('Success!', `Email send Successfully.`, 'success');
      }
      else{
        showSweetAlert('Warning!', `Email address is not verified.`, 'warning');
      }
     }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (userData) {
        setName(userData.name || name);
        setAlreadyAccount(userData.added_integrations);

        let currentIntegration = userData.integrations?.current_integration; // Safe optional chaining
        
        if (currentIntegration === 'IBKR') {
          if (openSettings) {
            setShowAuthorization(true);
          }
        } 
        else if (currentIntegration === 'etrade') {
          let xAccessToken = localStorage.getItem('xAccessToken');
          let xAccessTokenSecret = localStorage.getItem('xAccessTokenSecret');

          if (!xAccessToken && !xAccessTokenSecret) {
            try {
              const response = await eTradeAuth('etrade');
              setEtradeAuthData(response);

              localStorage.setItem('resource_owner_key', response.resource_owner_key);
              localStorage.setItem('resource_owner_secret', response.resource_owner_secret);
              setEtradeIntegrationName('E*Trade');
              handleOpenEtradeAuth();
            } catch (error) {
              console.error("E*Trade Authentication Failed:", error);
            }
          } else {
            if(!userData?.integrations?.trade_account_id){
              await etradeAllAcc();
              handleOpenAccSelect();
            }
            else{
              await holdingsData(currentIntegration, userData?.integrations?.trade_account_id);
              await getOrderData(currentIntegration, userData?.integrations?.trade_account_id);
              await getWatchLists(currentIntegration, userData?.integrations?.trade_account_id);
              await preformanceData(currentIntegration, userData?.integrations?.trade_account_id, '1D');
              await accountsSummary(currentIntegration, userData?.integrations?.trade_account_id, userData?.integrations?.trade_ins_type);
            }
          }
        }
        else if(currentIntegration === 'coinbase'){
          let coinAccessToken = localStorage.getItem('coinAccessToken');

          if(!coinAccessToken){
            try{
              const response = await eTradeAuth('coinbase');
              setEtradeAuthData(response);
              setEtradeIntegrationName('Coinbase');
              handleOpenEtradeAuth();
            }catch (error) {
              console.error("coinbase Authentication Failed:", error);
            }
          }
          else{
            await holdingsData(name);
            await getOrderData(name);
            await getWatchLists(name);
            await preformanceData(name, userData?.integrations?.trade_account_id, '1D');
            await accountsSummary(name);
          }
        }
      }
    };

    fetchData();
    // fetchUserData();
  }, [userData, name, openSettings]); // Include openSettings in dependency array if needed


  const handleAccountChange = async(accountName) => {
    let name = accountName.replace(/\s+|\*|\.com/gi, '').toLowerCase();
    
    if(accountName === 'InteractiveBrokers'){
      name = 'IBKR'
    }
    setThirdParyAccount(name);
    const updatedSettings = {
      ...(Object.keys(integrationsParams).length > 0
      ? integrationsParams
      : userData?.integrations || {}),
      current_integration: name,
    };
    await aiSettings(updatedSettings);

    if(name === 'IBKR'){
      if(openSettings === true){
        setShowAuthorization(true);
      }
    }
    if(name === 'etrade'){
      let xAccessToken = localStorage.getItem('xAccessToken');
      let xAccessTokenSecret = localStorage.getItem('xAccessTokenSecret');

      if(!xAccessToken && !xAccessTokenSecret){
        const response = await eTradeAuth('etrade');
        setEtradeAuthData(response);
        localStorage.setItem('resource_owner_key', response.resource_owner_key);
        localStorage.setItem('resource_owner_secret', response.resource_owner_secret);
        setEtradeIntegrationName(accountName);
        handleOpenEtradeAuth();
      }
      else{
        await holdingsData(name, userData?.integrations?.trade_account_id);
        await getOrderData(name, userData?.integrations?.trade_account_id);
        await getWatchLists(name, userData?.integrations?.trade_account_id);
        await preformanceData(name, userData?.integrations?.trade_account_id, '1D');
        await accountsSummary(name, userData?.integrations?.trade_account_id, userData?.integrations?.trade_ins_type);
      }
    }
    else if(name === 'coinbase'){
      let coinAccessToken = localStorage.getItem('coinAccessToken');

      if(!coinAccessToken){
        try{
          const response = await eTradeAuth('coinbase');
          setEtradeAuthData(response);
          setEtradeIntegrationName(accountName);
          handleOpenEtradeAuth();
        }catch (error) {
          console.error("coinbase Authentication Failed:", error);
        }
      }
      else{
        await holdingsData(name);
        await getOrderData(name);
        await getWatchLists(name);
        await preformanceData(name, userData?.integrations?.trade_account_id, '1D');
        await accountsSummary(name);
      }
    }
    // if(name !== 'etrade' || name !== 'coinbase'){
    //   await holdingsData(name, userData?.integrations?.trade_account_id);
    //   await getOrderData(name, userData?.integrations?.trade_account_id);
    //   await getWatchLists(name, userData?.integrations?.trade_account_id);
    //   await preformanceData(name, userData?.integrations?.trade_account_id, '1D');
    //   await accountsSummary(name, userData?.integrations?.trade_account_id, userData?.integrations?.trade_ins_type);
    // }
  };

  const getAccountImage= (account) => {
    switch(account){
      case 'CharlesSchwab': return 'traditional_charles.svg' ;
      case 'MerillLynch': return 'merill.svg';
      case 'MorganStanley': return 'morgan.svg';
      case 'J.P.Morgan': return 'jp_morgan.svg';
      case 'TD': return 'td.svg';
      case 'WellsFargo': return 'wells.svg';
      case 'CITI': return 'citi.svg';
      case 'InteractiveBrokers': return 'thirdp_ib.svg';
      case 'E*Trade': return 'etrade.svg';
      case 'TradeStation': return 'trade_station.svg';
      case 'Webull': return 'webull.svg';
      case 'Robinhood': return 'robin_hood.svg';
      case 'Tastytrade': return 'tastytrade.svg';
      case 'Bloomberg': return 'bloomberg.svg';
      case 'Coinbase': return 'crypto_coin.svg';
      case 'Crypto.com': return 'crypto.svg';
      case 'Binance': return 'binance.svg';
      case 'Kraken': return 'kraken.svg';
      case 'Gemini': return 'gemini.svg';
    }
  }

  return (
    <>
      <Navbar expand="lg">
        <Container fluid>
          <Navbar.Brand as={NavLink} to="/Home/Landing"><img src={`${process.env.PUBLIC_URL}/images/No Doji 1.svg`} className="header-logo" alt="logo" /></Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={NavLink} to="/Home/Landing" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                Home
              </Nav.Link>
              {/* <Nav.Link as={NavLink} to="/Home/Analyze">Analytics</Nav.Link> */}
              <Nav.Link as={NavLink} to="/Home/Portfolio">Portfolio</Nav.Link>
            </Nav>
            <Nav className="ml-auto right-nav">
              
              <Nav.Link><img src={`${process.env.PUBLIC_URL}/images/bar.svg`} alt="bar-icon" onClick={handleShowCustomWidget} /></Nav.Link>
              <Nav.Link><img src={`${process.env.PUBLIC_URL}/images/message.svg`} alt="message-icon" onClick={handleShowSupport} /></Nav.Link>
              <Nav.Link><img src={`${process.env.PUBLIC_URL}/images/setting.svg`} alt="setting-icon" onClick={handleOpenAccSettings} /></Nav.Link>
              <NavDropdown
                title={<img src={`${process.env.PUBLIC_URL}/images/user-circle.svg`} alt="user-img" />}
                id="settings-nav-dropdown"
                align="end" // Ensure dropdown aligns to the end
                menuVariant="dark"
              >
                <NavDropdown.Item href="#profile">My Profile</NavDropdown.Item>

                <NavDropdown.Item className="d-flex justify-content-between align-items-center"
                  onClick={(event) => { event.stopPropagation();  setShowAccounts(!showAccounts);}} >
                  Switch Account 
                  <img src={`${process.env.PUBLIC_URL}/images/down 2.svg`} alt="icon" style={{width:'18px', height:'17px', marginLeft:'14px'}} />
                </NavDropdown.Item> 
                {showAccounts && (
                  <>
                    <div className='mx-2'>
                      {alreadyAccount.map((account, index) => (
                        <NavDropdown.Item key={index} 
                          className="option d-flex align-items-center" 
                          onClick={() => {
                            if (account.name.toLowerCase() !== "robinhood") {
                              handleAccountChange(account.name);
                            }
                          }}
                        >
                          <img 
                            src={`${process.env.PUBLIC_URL}/images/switch_acc/${getAccountImage(account.name)}`} 
                            alt={account.name} 
                            style={{ width: '18px', height: '18px', marginRight: '14px', borderRadius: '8px' }} 
                          />
                          {account.name}
                        </NavDropdown.Item>
                      ))}
                      <NavDropdown.Item className='option' onClick={handleOpenSwitchAccount}>
                        Add another account
                      </NavDropdown.Item>
                    </div>
                    <hr className='my-0 mx-2 '/>
                  </>
                )}
                <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Modal show={showSupport} onHide={handleCloseSupport} centered >
        <Modal.Body className="support-dialog">
          <img src={`${process.env.PUBLIC_URL}/images/close.png`} alt="close" className="close-icon" role="button" onClick={handleCloseSupport} />
          <h6 className="large-text">Hello {name}! <br />How can we help you today?</h6>
          <Form onSubmit={handleSubmit} className="basic-form">
            <Form.Group>
              <Form.Control
                as="select"
                className="form-input custom-select mt-4" // Apply custom CSS class
                value={issueType}
                onChange={(e) => {
                  setIssueType(e.target.value);
                  if (e.target.value) {
                    setErrors((prevErrors) => ({ ...prevErrors, issueType: '' })); // Remove error
                  }
                }}
              >
                <option value="">Select your type of issue</option>
                <option value="General Issues">General Issues</option>
                <option value="Technical Issues">Technical Issues</option>
                <option value="Misc. Support Issues">Misc. Support Issues</option>
              </Form.Control>
            </Form.Group>
            {errors.issueType && <div className="text-danger mt-1">{errors.issueType}</div>}

            <Form.Group>
              <Form.Control
                as="textarea"
                className="form-input mt-4 support-desc"
                placeholder="Description"
                value={description}
                rows={4}
                onChange={(e) => {
                  setDescription(e.target.value);
                  if (e.target.value.trim()) {
                    setErrors((prevErrors) => ({ ...prevErrors, description: '' })); // Remove error
                  }
                }}
              />
            </Form.Group>
            {errors.description && <div className="text-danger mt-1">{errors.description}</div>}

            <div className="row justify-content-center submit-btn">
              <button type="submit" className="w-55 p-2 theme-btn btn-primary" style={{ color: "#FFF", border: "unset" }}>Submit</button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <AccountSettingsDialog open={openAccSettings} onClose={handleCloseAccSettings} />
      <CustomizeWidget open={isCustomizeWidgetOpen} onClose={handleCloseCustomWidget} />
      <SwitchAccount open={switchAccount} onClose={handleCloseSwitchAccount}/>
      <ETradeAuthorization open={etradeAuth} onClose={handleCloseEtradeAuth} currentIntegration={etradeIntegrationName}/>
      <EtradeAccSelection open={openAccSelect} onClose={handleCloseAccSelect}/>
      {showAuthorization && <Authorization open={showAuthorization} onClose={handleCloseSettings} />}
    </>
  );
}

export default Header;
